module.exports = __webpack_public_path__ + "static/media/pharmacy-error.3c16a685.svg";